export const ResolveOperations = Object.freeze({
  CANDIDATE: 1,
  CLIENT: 2,
  ORIGINAL: 3,
  TIME_ENTRY: 4,
})
